<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <div class=".title ma-2">
      Add a line
    </div>
    <v-form ref="addHctr" v-model="addHctrValid">
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-select v-model="fcti_code" required :items="fcti_codeKeuzes" item-value="fcti_code" item-text="fctitaal_oms" label="Item" dense :rules="fcti_codeRules"></v-select>
      </v-col>
     </v-row>
     <v-row no-gutters>
        <div v-if="isGarantiePeriode && fcti_code==='i1'" class="ma-2 pl-2 pr-2 py-1" style="display: flex;  flex-direction: row; align-items: center; text-align: center;  border: 2px solid orange; border-radius: 5px; color: orange; font-weight: 500;"><v-icon large color="orange" class="mr-1 mb-auto">mdi-alert-outline</v-icon>Booking falls into guarantee period. Normally you should NOT manually add rent lines.</div>
     </v-row>
     <v-row no-gutters v-if="hctr.betreft == 'Payment'">
          <v-col class="ma-2">
            <v-menu
              v-model="hctr_dtmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              readonly 
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="hctr_dt"
              label="Date"
              v-on="on"
              :rules="hctr_dtRules"
            ></v-text-field>
            </template>
            <v-date-picker v-model="hctr_dt" :first-day-of-week="1" @input="hctr_dtmenu = false"></v-date-picker>
            </v-menu>  
          </v-col>
      </v-row>
          
      <v-row no-gutters>
        <v-col class="ma-2">
          <v-text-field v-model="hctr_bedrag" required label="Amount" :prefix=hctr.valu_code type="number" :rules="hctr_bedragRules"></v-text-field>
        </v-col>
      </v-row>
       
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHctr" :disabled="!addHctrValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addHctrValid: false,
      hoct_encrid: null,
      fcti_code: '',
      isGarantiePeriode: false,
      hctr_bedrag: null,
      fcti_codeKeuzes: [],
      hctr: {},
      hctr_dtmenu: false,
      fcti_codeRules: [
          v => (v && v.length >= 1) || "An fcti code is required"
      ],
      hctr_dtRules: [
          v => (v && v.length >= 10) || "A date is required"
      ],
      hctr_bedragRules: [
          v => (v && v.length >= 1) || "An amount is required"
      ]    
    }
  },
  methods: {
    open(hoct_encrid,betreft) {
      // var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.hoct_encrid = hoct_encrid;
      this.fcti_codeKeuzes.length = 0;
      this.hctr_dt = '';
      this.hctr_bedrag = '';
      this.fcti_code = '';
      this.isGarantiePeriode = false;
      this.$axios
        .post("ares/json/ares/huov/hctr/getHoctToAddHctr2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHoctToAddHctr"
          },
          getHoctToAddHctr: {
            hoct_encrid: hoct_encrid,
            betreft: betreft
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            console.log(res.data.getHoctToAddHctr)
            this.hctr = res.data.getHoctToAddHctr
            this.isGarantiePeriode = res.data.getHoctToAddHctr.isGarantiePeriode
            this.fcti_codeKeuzes =  res.data.getHoctToAddHctr.fcti_codeKeuzes

            // res.data.getHoctToAddHctr.fcti_codeKeuzes.forEach(function(fcti) {
            // deze.fcti_codeKeuzes.push(fcti); 
            // });

          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addHctr() { 
      this.$axios
        .post("ares/json/ares/huov/hctr/addHctr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHctr"
          },
          addHctr: {
            hoct_encrid: this.hoct_encrid,
            fcti_code: this.fcti_code,
            hctr_dt: this.hctr_dt,
            hctr_bedrag: parseFloat(this.hctr_bedrag)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huov/onHuov/' + res.data.addHctr.huov_encrid);            
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHctr.text,
              color: res.data.addHctr.color
            }); 
            this.dialog = false;
          }
        })
    },
  }
}
</script>

